import React from 'react';
import { Provider } from 'react-redux';
import Routes from './routes';
import store from './store';
import GlobalStyles from './styles/global';
import { ThemeProvider } from 'styled-components'
import { COLORS } from './styles/colors.js'

const theme = {
  colors: COLORS
}

const App = () => (
	<Provider store={store}>
		<ThemeProvider theme={theme}>
		<Routes />
		<GlobalStyles />
		</ThemeProvider>
	</Provider>
);

export default App;
